<template>
    <div class="industry">
        <div class="industry_top">
            <div class="companyList">
				<div class="companyItem_bg" v-for="(item,index) in companyList" :key="index">
					<img src="@/assets/img/company_bg.png" alt="" class="company_bg">
					<div class="companyItem">
						<img :src="item.path" alt="" class="icon">
						<div class="companyItem_bottom">
							<div class="title">{{item.title}}</div>
							<div class="num">
								<countTo  :startVal='0' :endVal='Number(item.num)' :duration='800'></countTo>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="map" id="estateMapChart"></div>
        </div>
        <div class="industry_bottom">
            <div class="industry_title">安徽省十大新兴产业</div>
            <div class="industry_chart">
			    <div id="estateChart" style="width:100%;height:100%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
	import ahData from "@/common/china";
	import tenIndustry from "@/common/tenIndustry.json";
	export default {
		data() {
			return {
				companyList:[],
			}
		},
		mounted() {},
		methods:{
			getData(list1,list2){
				this.drawMapChart(list2);
				this.drawCart(tenIndustry);
				this.companyList = [
					{
						title:'全省企业数',
						path:require('@/assets/img/company_1.png'),
						num:list1.qys,
					},{
						title:'全省市场主体数',
						path:require('@/assets/img/company_2.png'),
						num:list1.sczt,
					},
				]
			},
			drawMapChart(list2) {
				let mapChart = this.$echarts.init(document.getElementById('estateMapChart'));
				this.$echarts.registerMap("ah", ahData);
				for(var i in list2){
					list2[i].name = list2[i].city
				}
				const option = {
					// 提示框组件
					tooltip: {
						trigger: 'item', 
						formatter: function (val) {
							return val.data.name + '<br>授权发明: ' + val.data.zl_fmshouq + '件' + '<br>有效发明: ' + val.data.zl_fmyoux + '件'
						}
					},
					series: [
						{
							type: 'map',
							map: "ah", //上面引入的数据名
							mapType: 'china',
							zoom:1.24,						
							label: {
								normal: {
									show: true,
									color: '#fff',
									fontSize:14,
									formatter: function (params) {
										return params.name+"\n"+ params.data.zl_qy_fmyoux_qy + '(家)';    //地图上展示文字 + 数值
									},
								},
							},
							itemStyle: {
								normal: {
									borderWidth:1,
									borderColor: "#07E2F4", //地图区域的边框
									areaColor: "#2498CF",
								},
								emphasis: { 
									label: {
										color: "#fff",
										show: true ,
									},
									areaColor: "#4F7FFF",
								}
							},
							data:list2,
						}
					],
				};
				mapChart.setOption(option);
				window.addEventListener("resize", function() {
					mapChart.resize();
				});
			},
			// 十大新兴产业
			drawCart(list) {
				let myChart = this.$echarts.init(document.getElementById('estateChart'));
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					textStyle: {
						color: '#fff',
					},
					grid: {
						left: '0',
						right: '0',
						top:'20%',
						bottom: '0',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data:list.map(item =>item.name),
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show:true,
						},
						axisTick: {		//坐标轴刻度与标签对齐
							alignWithLabel: true,
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					legend: {
						icon: 'rect',
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 24, // 设置间距
						right: 'center',
						top:'5%',
						data: ['授权', '有效'],
						textStyle: {
							color: '#fff',
						},
					},
					series: [
						{
							name: '授权',
							type: 'bar',
							barWidth: '35%',
							barGap: '5%',
							label: { //显示数值
								show: true,
								position: 'outside',
								color: '#fff'
							},
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#EB7425'
									}, // 设置颜色渐变
									{
										offset: 1,
										color: '#EDC458'
									}
								]
							}],
							data:list.map(item =>item.shouquan)
						},
                        {
							name: '有效',
							type: 'bar',
							barWidth: '35%',
							barGap: '5%',
							label: { //显示数值
								show: true,
								position: 'outside',
								color: '#fff'
							},
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#00C6F3'
									}, // 设置颜色渐变
									{
										offset: 1,
										color: '#0091F3'
									}
								]
							}],
							data:list.map(item =>item.youxiao)
						},
					],
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>